import { useContext, useEffect } from 'react';
import SearchResults from 'components/page/search';
import { useRouter } from 'next/router';
import { useTranslation } from 'tools/i18n';
import { TrackingContext } from 'components/providers/tracking';
import { GetServerSidePropsContext } from 'next';
import { appDataCache } from '@services/ServerCacheManager';

export default function SearchPage() {
    const router = useRouter();
    const { query } = router;
    const { actions: trackingActions } = useContext(TrackingContext);
    const { t } = useTranslation(['general']);

    useEffect(() => {
        trackingActions.pageImpression('Search results for ' + query.q, 'search');
    }, []);

    return (
        <SearchResults query={query} router={router} />
    );
}

export const getServerSideProps = async (context: GetServerSidePropsContext) => {
    const appData = await appDataCache(context);
    return {
        props: {
            appData,
        },
    };
};
